<span [ngClass]="{ red: isOverBenchmark }" style="font-weight: 600" [class.deactivated-gray]="isDeactivated">
  {{ dsoValue | emptyFormat }}
</span>
